import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Job';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $getJob = ActionCreator.Async(MODULE, 'Get.Shipment', (id) => {
  return async (dispatch) => {
    dispatch($processing($getJob.OPERATION));

    return await Rest.GET(`${API_URL}/tms/job/shipment/${id}`)
      .then((response) => {
        dispatch($getJob.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getJob.OPERATION)));
  };
});
